/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable')
    .factory('AdvancedFiltersService', ['SearchService', function(SearchService) {
        var wordExt = ['doc', 'docx', 'rtf', 'dot'],
            powerPointExt = ['ppt', 'pptx', 'pps', 'ppsx'],
            excelExt = ['xls', 'xlsx', 'xlt'],
            iWorksExt = ['key', 'numbers', 'pages', 'keynote'],
            pdfExt = ['pdf'],
            textExt = ['txt', 'text'],
            imageExt = ['bmp', 'gif', 'jpe', 'jpeg', 'jpg', 'ico', 'png', 'eps', 'tif', 'tiff'],
            videoExt = ['avi', 'mov', 'mpg', 'mpeg', 'wmv', 'm4v', 'mp4'],
            audioExt = ['mp3', 'wav', 'wma', 'aac', 'm4a'],
            now = new Date();
        
        return {
            fileTypes: [
                { name: 'All types', extensions: '' },
                { name: 'All documents', extensions: wordExt.concat(powerPointExt, excelExt, iWorksExt, pdfExt, textExt) },
                { name: 'Word', extensions: wordExt },
                { name: 'PowerPoint', extensions: powerPointExt },
                { name: 'Excel', extensions: excelExt },
                { name: 'PDF', extensions: pdfExt },
                { name: 'Text', extensions: textExt },
                { name: 'Image', extensions: imageExt },
                { name: 'Video', extensions: videoExt },
                { name: 'Audio', extensions: audioExt }
            ],
            periods: [
                {name: 'Any time', from: '', to: ''},
                {
                    name: 'Last day',
                    from: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
                    to: now
                }, {
                    name: 'Last week',
                    from: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
                    to: now
                }, {
                    name: 'Last month',
                    from: new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()),
                    to: now
                }, {
                    name: 'Last year',
                    from: new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()),
                    to: now
                }
            ],
            owners: [
                { name: 'Any owner', email: '' }
            ],
            advancedFiltersState: null
        }
    }]);
